import { categories } from "@/mocks/categories";

const featured = [
  {
    ...categories[0],
    width: "lg:col-span-2",
    label: "Mais Vendido",
    accent: "bg-accent-500",
  },
  {
    ...categories[1],
    width: "",
    label: "Tendência",
    accent: "bg-primary-500",
  },
  {
    ...categories[2],
    width: "",
    label: "Novidade",
    accent: "bg-secondary-500",
  },
];

export default function FeatureGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Categorias em Destaque
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Explore as Categorias
            <br />
            <span className="text-foreground-500">Mais Populares</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((cat, idx) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer h-[320px] md:h-[400px] ${cat.width}`}
            >
              <img
                src={cat.image}
                alt={cat.name}
                title={`Hoobuy ${cat.name}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>

              <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold text-background-50 ${cat.accent} whitespace-nowrap`}>
                {cat.label}
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-background-50/70 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-background-50/80 group-hover:text-background-50 transition-colors">
                  Explorar Categoria
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}